// Carts Store
import { isEmpty } from 'lodash'
import { getField, updateField } from 'vuex-map-fields'

const state = {
  cart: {},
  deliveryAddress: {},
  deliveryAddressCountryOptions: [],
  pending: {},
  errors: [],
}

const address = {
  firstname: null,
  city: null,
  address: null,
  house_number: [],
  lastname: null,
  country: {},
  gender: {},
  zip: null,
}

const getters = {
  getField,
}

const actions = {
  getShoppingCart({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING', { pending: true, type: 'getShoppingCart' })
      this.api.items
        .getItems('carts.mine')
        .then(({ data }) => {
          if (data.errors) {
            commit('SET_CART_FAIL')
            reject(data.errors)
            return
          }

          commit('SET_CART_SUCCESS', data)
          resolve(data)
        })
        .catch(errors => {
          commit('SET_CART_FAIL')
          reject(errors)
        })
        .finally(_ => {
          commit('SET_PENDING', { pending: false, type: 'getShoppingCart' })
        })
    })
  },
  addProductToCart({ commit }, product_id) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING', { pending: true, type: 'addProductToCart' })
      this.api.items
        .createItem('carts.mine.items', { product_id })
        .then(({ data }) => {
          if (data.errors) {
            commit('PRODUCT_ADDED_TO_CART_FAIL')
            reject(data.errors)
            return
          }

          commit('PRODUCT_ADDED_TO_CART_SUCCESS')
          resolve(data)
        })
        .catch(errors => {
          commit('PRODUCT_ADDED_TO_CART_FAIL')
          reject(errors)
        })
        .finally(_ => {
          commit('SET_PENDING', { pending: false, type: 'addProductToCart' })
        })
    })
  },
  saveDeliveryAddress({ commit }, { address }) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING', { pending: true, type: 'saveDeliveryAddress' })
      this.api.items
        .createItem('carts.mine.delivery_address', address)
        .then(({ data }) => {
          if (data.errors) {
            commit('SAVE_ADDRESS_FAIL')
            reject(data.errors)
            return
          }

          commit('SAVE_ADDRESS_SUCCESS')
          resolve(data)
        })
        .catch(errors => {
          commit('SAVE_ADDRESS_FAIL')
          reject(errors)
        })
        .finally(_ => {
          commit('SET_PENDING', { pending: false, type: 'saveDeliveryAddress' })
        })
    })
  },
  purchase({ commit }, agb) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING', { pending: true, type: 'purchase' })
      this.api.items
        .createItem('payments', { agb })
        .then(({ data }) => {
          if (data.result && data.redirect) {
            window.location.href = data.redirect
          } else if (data.redirect === '' || data.redirect === null) {
            commit('PURCHASE_EMPTY_REDIRECT_FAIL')
            reject({ emptyRedirect: true })
          } else {
            commit('PURCHASE_FAIL')
            reject(data)
          }
          commit('PURCHASE_SUCCESS')
          resolve(data)
        })
        .catch(errors => {
          commit('PURCHASE_FAIL')
          reject(errors)
        })
        .finally(_ => {
          commit('SET_PENDING', { pending: false, type: 'purchase' })
        })
    })
  },
  removeProduct({ commit, dispatch }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.deleteItem(`carts.mine.items.${id}`)
      .then(_ => {
        dispatch('getShoppingCart')
        commit('LAST_REMOVE_PRODUCT')
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  updateCartItemOption({ commit, dispatch }, { id, option }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.editItem(`carts.mine.items.${id}`, option)
      .then(({ data }) => {
        commit('SET_PENDING')
        dispatch('getShoppingCart')
        resolve(data)
      })
    })
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  SET_CART_SUCCESS(state, { cart, delivery_address, form_options }) {
    state.cart = cart

    if (isEmpty(delivery_address)) {
      state.deliveryAddress = address
    } else {
      state.deliveryAddress = delivery_address
    }

    state.deliveryAddressCountryOptions = form_options.delivery_address_country_options
  },
  LAST_REMOVE_PRODUCT: _ => {
    return true
  },
  updateField,
}

const history_commits = [
  'PRODUCT_ADDED_TO_CART_FAIL',
  'SET_CART_FAIL',
  'SAVE_ADDRESS_FAIL',
  'PRODUCT_ADDED_TO_CART_SUCCESS',
  'SAVE_ADDRESS_SUCCESS',
  'PURCHASE_EMPTY_REDIRECT_FAIL',
  'PURCHASE_FAIL',
  'PURCHASE_SUCCESS',
]

history_commits.forEach(commit => {
  mutations[commit] = _ => true
})

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
